import { PlatformMessageDto } from '@halo/dtos/platform-message.dto'

export class MessageTableDataDto extends PlatformMessageDto {
    public static fromMessageDto(fields: Partial<MessageTableDataDto>): MessageTableDataDto {
        const dto = new MessageTableDataDto()
        Object.assign(dto, fields, {
            key: fields.id,
        })
        return dto
    }

    public readonly key: number
}
